<template>
</template>
<script>
    import PreviewElement from "./PreviewElement";
    import IconElement from "../../components/pagesbuilder/elements/IconElement";

    export default {
        name: "PreviewIconElement",
        mixins: [PreviewElement,IconElement]
    }
</script>
